<template>
  <div>
    <vx-card title="Historial de consultas pre-aprobación"  style="height: 230px;
    overflow: hidden;
    overflow-y: scroll;
    font-size: 12px;
}">
      <vs-table stripe :data="records">
        <template slot="thead">
          <vs-th>Fecha</vs-th>
          <vs-th>Version</vs-th>
          <vs-th>Score</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="event in data" :key="event.id">
            <vs-td>{{ event.request_date|_humanizeDate }}</vs-td>
            <vs-td>{{ event.versionName }}</vs-td>
            <vs-td>{{ event.score|fixNumber }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {_humanizeDate} from "../../../../../../filters/momentTzConvert";
import {fixNumber} from "@/filters/NumberFilters";

export default {
  name: "PreApproveHistory",
  computed: {
    ...mapState("projects", ["project"]),
  },
  filters: {
    fixNumber,
    _humanizeDate
  },
  props: {
    records: {
      required: true
    }
  },
}
</script>

<style scoped>

</style>
